module.exports = __webpack_public_path__ + "img/maPread_text_color.844b074a.svg";